import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { NumberingWizardPropsType } from "../../../../Type/FormLayoutType";
import { AboveInformationCorrect, AdharPlaceholder, CVVNumber, CardNumber, Expiration, ExpiryPlaceholder, PlaceHolderName, PlaceholderName, UploadDocumentation } from "../../../../Constant";

const CartInfoForm = ({ getUserData, basicInputFormValue }: NumberingWizardPropsType) => {
  const { placeHolderName, cardNumber, expiration, cvvNumber } = basicInputFormValue;

  return (
    <Form className="stepper-two g-3 needs-validation custom-input" noValidate>
      <Row>
      <Col md="12" className="mb-3">
        <Label check>{PlaceHolderName}</Label>
        <Input name="placeHolderName" value={placeHolderName} onChange={getUserData} type="text" placeholder={PlaceholderName} />
      </Col>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{CardNumber}</Label>
        <Input name="cardNumber" value={cardNumber} onChange={getUserData} type="text" placeholder={AdharPlaceholder} />
      </Col>
      <Col xxl="4" sm="6" className="mb-3">
        <Label check>{Expiration}</Label>
        <Input name="expiration" value={expiration} onChange={getUserData} type="number" placeholder={ExpiryPlaceholder} />
      </Col>
      <Col xxl="4" className="mb-3">
        <Label check>{CVVNumber}</Label>
        <Input name="cvvNumber" value={cvvNumber} onChange={getUserData} type="text" />
      </Col>
      <Col xs="12" className="mb-3">
        <Label check>{UploadDocumentation}</Label>
        <Input name="uploadDocumentation" onChange={getUserData} type="file" />
      </Col>
      <Col xs="12">
        <FormGroup check>
          <Input id="invalidCheck-a" name="informationCheckBox" onChange={getUserData} type="checkbox" required />
          <Label className="form-check-label" htmlFor="invalidCheck-a" check>{AboveInformationCorrect}</Label>
        </FormGroup>
      </Col>
      </Row>
    </Form>
  );
};

export default CartInfoForm;
